import {
  Button,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { SummaryType } from '@src/lib/types/purchases';
import numeral from 'numeral';

const TableRowItem = (props: SummaryType) => {

  const navigate = useNavigate();

  const onViewUserDetails = () => {
    switch(props.fundType){
      case "POINT":
        navigate(`/dashboard/purchase/points-purchases`);
        break; 
      case "CASH":
        navigate(`/dashboard/purchase/cash-purchases`);
        break; 
      case "GOLD":
        navigate(`/dashboard/purchase/gold-purchases`);
        break; 
    }
  }

  return (
    <TableRow hover tabIndex={-1} role="checkbox" >
      <TableCell onClick={onViewUserDetails} >
        <Button variant='contained' sx={{bgcolor: "#E5EFF4"}}>
          <Typography variant="subtitle2" color={"#457DBF"} sx={{ textTransform: "capitalize" }}>
            {formatTitle(props.fundType)} Purchases
          </Typography>
        </Button>
      </TableCell>
      <TableCell align="center">{numeral(props.transactionCount).format("0,000")}</TableCell>
      <TableCell align="center">{numeral(props.totalAmount).format("0,000")}</TableCell>
      <TableCell align="center">{props.mostPurchasedItem}</TableCell>
      <TableCell align="center">{numeral(props.successCount).format("0,000")}</TableCell>
      <TableCell align="center">{numeral(props.failureCount).format("0,000")}</TableCell>
    </TableRow>
  );
}

const formatTitle = (text?: string) =>
  text
    ?.toLowerCase()
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());

export default TableRowItem;
